import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getKrs = createAsyncThunk("krs/getAll", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get('v1/master/krs');
    return response.data;
});
export const getKrsById = createAsyncThunk("krs/getById", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/krs/${id}`);
    
    return response.data;
});

export const deleteKrs = createAsyncThunk("krs/delete", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    await jwtAuthAxios.delete(`v1/master/krs/${id}`);
    return id;
});

export const saveKrs = createAsyncThunk("krs/save", async(data) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/master/krs',data);
    return response.data;
});
export const updateKrs = createAsyncThunk("krs/update", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    console.log("request : ",request)
    const response = await jwtAuthAxios.put('v1/master/krs',request);
    return response.data;
});

const initialState = {
    loading: false,
    listKrs: [],
    selectedKrs: {},
}

const krsSlice = createSlice({
    name:"krs",
    initialState: initialState,
    extraReducers: {
        [getKrs.pending] : (state, action) => {
            state.loading = true;
        },
        [getKrs.fulfilled] : (state, action) => {
            state.listKrs = action.payload;
            state.loading = false;
        },
        [getKrs.rejected] : (state, action) => {
            state.loading = false;
        },

        [getKrsById.pending] : (state, action) => {
            state.loading = true;
        },
        [getKrsById.fulfilled] : (state, action) => {
            state.loading = false;
            state.selectedKrs = action.payload;
        },
        [getKrsById.rejected] : (state, action) => {
            state.loading = false;
        },

        [deleteKrs.pending] : (state, action) => {
            state.loading = true;
        },
        [deleteKrs.fulfilled] : (state, action) => {
            state.loading = false;
        },
        [deleteKrs.rejected] : (state, action) => {
            state.loading = true;
        },

        [saveKrs.pending] : (state, action) => {
            state.loading = true;
        },
        [saveKrs.fulfilled] : (state, action) => {
            state.loading = false;
            state.selectedKrs = action.payload;
        },
        [saveKrs.rejected] : (state, action) => {
            state.loading = false;
        },

        [updateKrs.pending] : (state, action) => {
            state.loading = true;
        },
        [updateKrs.fulfilled] : (state, action) => {
            state.loading = false;
            state.selectedKrs = action.payload;
        },
        [updateKrs.rejected] : (state, action) => {
            state.loading = false;
        },

    }
})

export const krsSelector = (state) => state.krs;
export default krsSlice.reducer;